// src/pages/auth/LoginForm.js
import React, { useState } from 'react';

const LoginForm = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (email === '' || password === '') {
            setError('Email and password are required');
            return;
        }

        console.log('Submitting:', email, password);

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            if (response.ok) {
                const userData = await response.json();
                console.log('Login successful:', userData);
                setError('');
                onLogin(userData); // Передаем данные пользователя
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Invalid credentials');
            }
        } catch (error) {
            console.error('Error during login:', error);
            setError('An error occurred. Please try again.');
        }
    };

    return (
        <div className="login-container">
            <h2>Вход</h2>
            <form className="login-form" onSubmit={handleSubmit}>
                <input type="email" placeholder="E-mail" value={email} onChange={e => setEmail(e.target.value)} required />
                <input type="password" placeholder="Пароль" value={password} onChange={e => setPassword(e.target.value)} required />
                <button type="submit">Войти</button>
                {error && <p className="error">{error}</p>}
            </form>
            <h5>Забыли пароль? <a href="/reset-password">Сбросить пароль</a></h5>
            <h5>Нет учетной записи? <a href="/register">Зарегистрируйтесь</a></h5>
        </div>
    );
};

export default LoginForm;
